import { IconButton } from '@mui/material'
import PropTypes from 'prop-types'

/**
 * MyIconButton is a custom component that renders an IconButton from the Material-UI library.
 * 
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered IconButton component.
 */
const MyIconButton = ({ children, onClick, ...props }) => {
    return (
        <IconButton
            color='secondary'
            onClick={onClick}
            {...props}
        >
            {children}
        </IconButton>
    )
}

MyIconButton.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func
}

export { MyIconButton as IconButton }
